import { ITag } from '../../models/ITag';

export function isCiCdTag(tag: ITag) {
    return tag.message.indexOf('_github_deploy') > -1;
}
